<div class="component-viewer">
  <mat-card>
    <mat-card-header style="display: inline;">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center gap-5">
          <h2 class="mb-0">Membership Plans</h2>
        </div>
        <button mat-raised-button (click)="addMembershipPlan()">
          Add <mat-icon>add</mat-icon>
        </button>
      </div>
    </mat-card-header>
    <mat-card-content>
      <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
      [filter]="filter" [data]="membershipPlans" (filterChanged)="getMembershipPlans()" (filterReset)="resetFilter()">
    </gt-table>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      <table mat-table [dataSource]="membershipPlans" matSort (matSortChange)="sortData($event)">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let plan"> {{ plan.name }} </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef> Description </th>
          <td mat-cell *matCellDef="let plan"> {{ plan.description }} </td>
        </ng-container>
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef> Price </th>
          <td mat-cell *matCellDef="let plan"> {{ plan.price | currency }} </td>
        </ng-container>
        <ng-container matColumnDef="billingInterval">
          <th mat-header-cell *matHeaderCellDef> Interval </th>
          <td mat-cell *matCellDef="let plan"> {{ plan.billingInterval | titlecase }} </td>
        </ng-container>
        <ng-container matColumnDef="billingIntervalCount">
          <th mat-header-cell *matHeaderCellDef> Interval Count </th>
          <td mat-cell *matCellDef="let plan"> {{ plan.billingIntervalCount }} </td>
        </ng-container>
        <ng-container matColumnDef="maxBookingsPerMonth">
          <th mat-header-cell *matHeaderCellDef> Max Bookings/Month </th>
          <td mat-cell *matCellDef="let plan">
            <ng-container *ngIf="plan.maxBookingsPerMonth === 0">Unlimited</ng-container>
            <ng-container *ngIf="plan.maxBookingsPerMonth > 0">{{ plan.maxBookingsPerMonth }}</ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="discountPercent">
          <th mat-header-cell *matHeaderCellDef> Discount (%) </th>
          <td mat-cell *matCellDef="let plan"> {{ plan.discountPercent }} </td>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <th mat-header-cell *matHeaderCellDef> Active </th>
          <td mat-cell *matCellDef="let plan">
            <mat-icon *ngIf="plan.isActive">check_circle</mat-icon>
            <mat-icon color="warn" *ngIf="!plan.isActive">cancel</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let plan">
            <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionsMenu>
              <button mat-menu-item (click)="editMembershipPlan(plan)">
                Edit <mat-icon>edit</mat-icon>
              </button>&nbsp;
              <button mat-menu-item (click)="deleteMembershipPlan(plan)">
                Delete <mat-icon>delete</mat-icon>
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="!isLoading && membershipPlans.length === 0" class="mt-3 text-center">
        No membership plans found.
      </div>
    </mat-card-content>
  </mat-card>
</div>
